import { Button } from '@/components/ui/button';
import { GridIcon, ListIcon } from '@/components/ui/custom/icons';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useArtifactStore } from '@/store/artifactStore';
import { useUIStore } from '@/store/uiStore';
import React, { useCallback } from 'react';

interface ViewControlsProps {
  className?: string;
}

export const ViewControls: React.FC<ViewControlsProps> = ({ className }) => {
  const { } = useArtifactStore();
  const { viewMode, sortOption, setViewMode, setSortOption } = useUIStore();

  const handleViewToggle = useCallback(() => {
    const newViewMode = viewMode.type === 'grid'
      ? { type: 'list' as const }
      : { type: 'grid' as const, itemsPerRow: 3 };
    setViewMode(newViewMode);
  }, [viewMode.type, setViewMode]);

  const handleSortChange = useCallback((value: string) => {
    const fieldMap: Record<string, { field: 'title' | 'createdAt' | 'updatedAt' | 'size'; direction: 'asc' | 'desc' }> = {
      'name': { field: 'title', direction: 'asc' },
      'created': { field: 'createdAt', direction: 'desc' },
      'updated': { field: 'updatedAt', direction: 'desc' },
    };
    setSortOption(fieldMap[value]);
  }, [setSortOption]);

  return (
    <div className={`flex items-center justify-between gap-4 py-4 bg-card/50 w-full ${className || ''}`}>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={handleViewToggle}
          className="flex items-center gap-2"
        >
          {viewMode.type === 'grid' ? (
            <>
              <ListIcon />
              <span className="hidden sm:inline">List View</span>
            </>
          ) : (
            <>
              <GridIcon />
              <span className="hidden sm:inline">Grid View</span>
            </>
          )}
        </Button>
      </div>

      <div className="flex items-center gap-2">
        <span className="text-sm text-muted-foreground">Sort by:</span>
        <Select value={sortOption.field === 'title' ? 'name' : sortOption.field === 'createdAt' ? 'created' : 'updated'} onValueChange={handleSortChange}>
          <SelectTrigger className="w-32">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="name">Name</SelectItem>
            <SelectItem value="created">Created</SelectItem>
            <SelectItem value="updated">Updated</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}; 